export const AppIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9943 13.9529C15.4397 13.451 14.7775 13.2 14.0079 13.2C13.1997 13.2 12.5099 13.4768 11.9388 14.0304C11.3676 14.5734 11.0874 15.2335 11.0874 16C11.0874 16.7666 11.3676 17.4266 11.9388 17.9802C12.5099 18.5232 13.1997 18.8 14.0079 18.8C14.7775 18.8 15.4397 18.549 15.9943 18.0563C16.549 18.549 17.2111 18.8 17.9807 18.8C18.789 18.8 19.4787 18.5232 20.0499 17.9802C20.621 17.4266 20.912 16.7666 20.912 16C20.912 15.2335 20.621 14.5734 20.0499 14.0304C19.4787 13.4768 18.789 13.2 17.9807 13.2C17.2111 13.2 16.549 13.451 15.9943 13.9529ZM13.6954 17.8631C13.954 18.289 14.2342 18.5019 14.536 18.5019C14.9132 18.5019 15.1179 17.9377 15.1179 17.0434C15.1179 16.5962 15.0425 16.1065 14.9024 15.5635C14.7623 15.0205 14.5683 14.5521 14.2989 14.1369C14.0295 13.7217 13.7493 13.5088 13.4583 13.5088C13.0919 13.5088 12.9087 13.9666 12.9087 14.8928C12.9087 15.3506 12.9733 15.851 13.1027 16.4046C13.2428 16.9475 13.4367 17.4373 13.6954 17.8631ZM17.6682 17.8631C17.9268 18.289 18.207 18.5019 18.5088 18.5019C18.886 18.5019 19.0907 17.9377 19.0907 17.0434C19.0907 16.5962 19.0153 16.1065 18.8752 15.5635C18.7351 15.0205 18.5411 14.5521 18.2717 14.1369C18.0023 13.7217 17.7221 13.5088 17.4311 13.5088C17.0647 13.5088 16.8815 13.9666 16.8815 14.8928C16.8815 15.3506 16.9462 15.851 17.0755 16.4046C17.2156 16.9475 17.4096 17.4373 17.6682 17.8631Z"
        fill="#0B1115"
      />
      <path
        d="M20.1069 1.60001H11.8935C10.2507 1.60001 9.4293 1.60001 8.80182 1.94879C8.24988 2.25558 7.80114 2.74512 7.51991 3.34724C7.2002 4.03175 7.2002 4.92784 7.2002 6.72001V25.28C7.2002 27.0722 7.2002 27.9683 7.51991 28.6528C7.80114 29.2549 8.24988 29.7444 8.80182 30.0512C9.4293 30.4 10.2507 30.4 11.8935 30.4H20.1069C21.7497 30.4 22.5711 30.4 23.1986 30.0512C23.7505 29.7444 24.1993 29.2549 24.4805 28.6528C24.8002 27.9683 24.8002 27.0722 24.8002 25.28V6.72001C24.8002 4.92784 24.8002 4.03175 24.4805 3.34724C24.1993 2.74512 23.7505 2.25558 23.1986 1.94879C22.5711 1.60001 21.7497 1.60001 20.1069 1.60001Z"
        stroke="#434647"
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2002 3.60001H16.8002"
        stroke="#0B1115"
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
